<template>
  <div class="input-coupon-code" style="display:none">
    <slot name="txtBefore"></slot>
    <SimonModal
      :is-visible="show_"
      @hide="closeModal"
      id="input-coupon-code-modal"
    >
      <template v-slot:modalTitle>
        <h1>
          <slot name="txtCouponRedeemModalTitle">Gutschein? Sauber!</slot>
        </h1>
      </template>
      <div class="txtBeforeInfoBox"><slot name="txtCouponRedeemModalBeforeInfoBox"></slot></div>
      <div class="coupon-redeemed-modal-body infoBox">
        <div class="coupon-modal-body coupon-redeemed-modal-body">
          <div class="form-wrapper">
            <div v-if="validPromoCode" class="coupon-modal-subline-code">{{ validPromoCode }}</div>
            <div class="coupon-modal-subline"><slot name="couponModalInfo"></slot></div>
          </div>
        </div>
        <div class="modalCustomButtomBtn text" v-if="showDelete">
          <img src="files/flash/images/svg-icons/trashbin.svg" alt="Delete" @click="trashBinClicked()">
        </div>
      </div>
    </SimonModal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { required, sameAs } from 'vuelidate/lib/validators'
import isValid from '@/mixins/validators/isValid'
import validationFlow from '@/mixins/validators/validationFlow'
import passwordValidator from '@/mixins/validators/passwordValidator'
import { validationMixin } from 'vuelidate'
import syncProperty from '@/mixins/syncProperty'
import transaction from '@/mixins/transaction'
import shoppingCartMobile from '@/mixins/shoppingCartMobile'
import SimonModal from '@/components/modal/SimonModal.vue'

export default {
  name: 'CouponRedeemedModal',
  data () {
    return {
      loading: false,
      oldPassword: '',
      oldPasswordInvalid: false,
      password: '',
      passwordRepeat: '',
      passwordInvalid: false
    }
  },
  props: {
    shoppingCartWasOpen: {
      type: Boolean,
      default: false
    },
    showReedemedModal: {
      type: Boolean,
      default: false
    },
    showDelete: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapGetters('promotion/promoCode', {
      storedCouponRedeemed: 'couponRedeemed',
      redeemedPromoCode: 'validPromoCode',
      codePromotions: 'codePromotions',
      couponTypeCredit: 'couponTypeCredit',
      couponTypeVolume: 'couponTypeVolume',
      couponDiscountAmount: 'couponDiscountAmount',
      couponVolumeAmount: 'couponVolumeAmount'
    }),
    ...mapGetters('checkout', [
      'showProcess'
    ]),
    ...mapGetters('checkout/info', [
      'msisdn'
    ]),
    ...mapGetters('promotion/promoCode/', [
      'validPromoCode'
    ])
  },
  components: {
    SimonModal
  },
  mixins: [
    validationMixin,
    isValid,
    validationFlow,
    passwordValidator,
    transaction('changePassword'),
    syncProperty('show', 'show_'),
    shoppingCartMobile()
  ],
  mounted () {
    this.resetInput()
  },
  methods: {
    ...mapActions('changePassword', [
      'changePassword'
    ]),
    ...mapActions('promotion/promoCode', [
      'removePromoCode',
      'checkPromoCode'
    ]),
    onInput () {
      this.$store.commit('clearMessages', {}, { root: true })
    },
    resetInput () {
      this.$store.commit('clearMessages', {}, { root: true })
      this.vflowResetFeedbackStates()
    },
    next () {
      this.vflowForceFeedback()
      if (this.$refs.passwordInput) {
        this.$refs.passwordInput.vflowForceFeedback()
      }
      if (!this.passwordInvalid) {
        this.loading = true
        this.changePassword({ oldPassword: this.oldPassword, newPassword: this.password })
          .then((response) => {
            if (response?.data?.changePassword?.success === true) {
              this.successToast(this.$slots.txtToastChanged ? this.$slots.txtToastChanged[0].text : 'Das Passwort wurde erfolgreich geändert.')
              this.oldPasswordInvalid = false
              this.show_ = false
              this.password = ''
              this.passwordRepeat = ''
              this.oldPassword = ''
            }
            this.loading = false
          }, () => {
            this.loading = false
          })
      }
    },
    back () {
      this.password = ''
      this.passwordRepeat = ''
      this.oldPassword = ''
      this.$store.commit('clearMessages', {}, { root: true })
      this.show_ = false
    },
    closeModal () {
      this.resetInput()
      if (this.shoppingCartWasOpen) {
        this.openDrawer()
      }
      this.show_ = false
    },
    trashBinClicked () {
      this.removePromoCode()
        .then((response) => {
          this.loading = false
          this.removeClassForCheckList()
          this.checkPromoCode({ context: this.showProcess, msisdn: this.showProcess === 'activation' ? this.msisdn : null })
          this.$emit('update:showCouponRedeemedModal', false)
          this.successToast('Dein Gutschein wurde erfolgreich entfernt!')
        }, () => {
          this.loading = false
          this.removeClassForCheckList()
        })
    },
    removeClassForCheckList () {
      if (!this.couponRedeemed && !this.couponTypeVolume) {
        const otherContainer = document.getElementsByClassName('check-list')
        if (otherContainer.length !== 0) {
          for (const container of otherContainer) {
            container.classList.remove('has-promo-1')
          }
        }
      }
    }
  },
  validations () {
    return {
      oldPassword: {
        required
      },
      password: {
        required,
        passwordValidation (v) {
          return this.validatePassword(v)
        }
      },
      passwordRepeat: {
        required,
        sameAsPassword: sameAs(function () {
          return this.password
        })
      }
    }
  }
}
</script>
